import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, HardHat, Award } from "lucide-react";

export default function About() {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Image */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-3 border-2 border-cyan-600/30 rounded-sm"></div>
              <img
                src="/images/about.jpg"
                alt="Fabrika içi makine bakımı"
                className="relative w-full h-[480px] object-cover rounded-sm"
                loading="lazy"
              />
              <div className="absolute -bottom-5 -right-5 bg-slate-900 text-white px-5 py-4 rounded-sm shadow-xl hidden sm:block">
                <div className="text-[10px] font-mono-accent text-cyan-400 tracking-[0.22em]">DATAVIB / TEAM</div>
                <div className="text-base font-semibold">Saha + analiz + raporlama</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-tick"></span>
              <span className="overline">HAKKIMIZDA</span>
            </div>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.1]"
              style={{ fontFamily: "Outfit" }}
            >
              Endüstriyel ekipmanlar için
              <br />
              <span className="text-cyan-600">tek noktadan çözüm ortağınız.</span>
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              DATAVIB; kestirimci bakım, mekanik servis ve endüstriyel otomasyon
              alanlarında saha tecrübesi yüksek bir ekiple çalışır. Ölçüm, analiz,
              uygulama ve raporlama süreçlerini kendi ekibimiz ve ihtiyaca göre
              çözüm ortaklarımızla birlikte yürütüyor; fabrikalara hızlı ve
              sürdürülebilir destek sunmayı amaçlıyoruz.
            </p>

            {/* Mini values */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <Value icon={ShieldCheck} title="Güvenli saha" body="İSG kurallarına uyumlu, risk değerlendirmeli çalışma yaklaşımı." />
              <Value icon={HardHat} title="Saha tecrübesi" body="Fan, pompa, motor, redüktör başta olmak üzere geniş ekipman tecrübesi." />
              <Value icon={Award} title="Kalite odaklı" body="Standart bazlı ölçüm ve şeffaf raporlama yaklaşımı." />
            </div>

            <div className="mt-8">
              <a
                href="#iletisim"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("iletisim")?.scrollIntoView({ behavior: "smooth" });
                }}
                data-testid="about-cta-btn"
                className="btn-primary"
              >
                Keşif planlayalım <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Value({ icon: Icon, title, body }) {
  return (
    <div className="border-l-2 border-cyan-600 pl-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon className="w-4 h-4 text-cyan-600" />
        <div className="text-sm font-bold text-slate-900">{title}</div>
      </div>
      <div className="text-xs text-slate-600 leading-relaxed">{body}</div>
    </div>
  );
}
